import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getBiometricDetailsData
};

async function getGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"];
        }
    }
    return groupArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet(
        '/api/OperationEntity/GetAllEstateFilteredOperationEntityByGroupID',
        'groupID=' + id
    );
    for (let item of Object.entries(response.data)) {
        estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return estateArray;
}

async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet(
        '/api/CollectionPoint/GetAllDivisionsByEstateID',
        'estateID=' + id
    );
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
        }
    }
    return divisionArray;
}

async function getBiometricDetailsData(data) {
    const model = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID)
    };
    const response = await CommonPost(
        '/api/BiometricDetailsReport/GetBiometricDetailsData',
        null,
        model
    );
    return response.data;
}